import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import { SitePageShell } from '@/shared/ui';
import { MyQuoteDetail } from '@/widgets/my-quote-detail';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 내 견적 상세 페이지(견적 설계 §7-2). 인쇄 때는 견적서만 남도록 헤더·푸터를 숨긴다. */
export const MyQuoteDetailPage = (): ReactElement => {
  const { id = '' } = useParams();
  const parsed = normalizedUuidSchema.safeParse(id);

  return (
    <SitePageShell
      header={
        <div className="print:hidden">
          <SiteHeader />
        </div>
      }
      footer={
        <div className="print:hidden">
          <SiteFooter />
        </div>
      }
      className="pt-10 sm:pt-12 print:p-0"
    >
      <MyQuoteDetail id={parsed.success ? parsed.data : ''} validId={parsed.success} />
    </SitePageShell>
  );
};
